/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Save_User_ButtonInputs */

const en_team_manager_save_user_button = /** @type {(inputs: Team_Manager_Save_User_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save User`)
};

const fr_team_manager_save_user_button = /** @type {(inputs: Team_Manager_Save_User_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer l’utilisateur`)
};

const de_team_manager_save_user_button = /** @type {(inputs: Team_Manager_Save_User_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer speichern`)
};

const it_team_manager_save_user_button = /** @type {(inputs: Team_Manager_Save_User_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva utente`)
};

const ru_team_manager_save_user_button = /** @type {(inputs: Team_Manager_Save_User_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранить пользователя`)
};

const es_team_manager_save_user_button = /** @type {(inputs: Team_Manager_Save_User_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar usuario`)
};

const zh_cn2_team_manager_save_user_button = /** @type {(inputs: Team_Manager_Save_User_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存用户`)
};

const ja_team_manager_save_user_button = /** @type {(inputs: Team_Manager_Save_User_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザーを保存`)
};

const hi_team_manager_save_user_button = /** @type {(inputs: Team_Manager_Save_User_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपयोगकर्ता को सहेजें`)
};

const pt_pt2_team_manager_save_user_button = /** @type {(inputs: Team_Manager_Save_User_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar usuário`)
};

/**
* | output |
* | --- |
* | "Save User" |
*
* @param {Team_Manager_Save_User_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_save_user_button = /** @type {((inputs?: Team_Manager_Save_User_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Save_User_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_save_user_button(inputs)
	if (locale === "de") return de_team_manager_save_user_button(inputs)
	if (locale === "it") return it_team_manager_save_user_button(inputs)
	if (locale === "ru") return ru_team_manager_save_user_button(inputs)
	if (locale === "es") return es_team_manager_save_user_button(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_save_user_button(inputs)
	if (locale === "ja") return ja_team_manager_save_user_button(inputs)
	if (locale === "hi") return hi_team_manager_save_user_button(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_save_user_button(inputs)
	return en_team_manager_save_user_button(inputs)
});